import axios from 'axios';

const API_URL = process.env.REACT_APP_API_BASE_URL || (process.env.REACT_APP_BACKEND_URL ? `${process.env.REACT_APP_BACKEND_URL}/api` : 'http://localhost:5000/api');

const grantService = {
    getGrants: async (params, token) => {
        const config = {
            headers: { Authorization: `Bearer ${token}` },
            params
        };
        const response = await axios.get(`${API_URL}/grants`, config);
        return response.data;
    },

    getStats: async (token) => {
        const config = {
            headers: { Authorization: `Bearer ${token}` }
        };
        const response = await axios.get(`${API_URL}/grants/stats`, config);
        return response.data;
    }
};

export default grantService;
